import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Loading from "../../components/Loadings/LoadingTable";
import { RouteMode } from "../../constant/enum/RouteAccessLevel";
import { ManagementLayout } from "../../layout/ManagementLayout";
import ProtectedRoute from "../../layout/ProtectedLayout/ProtectedRoute";
import { ManagementRoute } from "../../routers/ManagementRoute";
import { ManagementStyle } from "./ManagementStyle";

const Management = () => {
  const renderRoute = () => {
    return ManagementRoute.map((route, index) => (
      <Route key={route.path} path={route.path} element={route.component} />
    ));
  };

  return (
    <ManagementStyle>
      <ProtectedRoute layoutMode={RouteMode.MANAGEMENT_ROUTE}>
        <ManagementLayout>
          <Suspense fallback={<Loading />}>
            <Routes>{renderRoute()}</Routes>
          </Suspense>
        </ManagementLayout>
      </ProtectedRoute>
    </ManagementStyle>
  );
};

export default Management;
